export default class SettingsProfileController {
  constructor(Profile, Upload, ENV) {
    'ngInject';

    this.Profile = Profile;
    this.Upload = Upload;
    this.ENV = ENV;
  }

  $onInit() {
    this.avatarDataUrl = this.settings.profile.avatar_urls.large;
  }

  handleProfileUpdate(profile) {
    this.updating = true;
    this.Upload
      .upload({
        url: `${this.ENV.apiUrl}/pingsta/profile`,
        method: 'PUT',
        data: profile.toJSON(),
      })
      .then((response) => {
        this.settings.profile = new this.Profile(response.data);
        this.updating = false;
      });
  }

  handleAvatarUpload(file) {
    this.settings.profile.avatar = file;
    this.Upload.dataUrl(file, true).then((url) => {
      this.avatarDataUrl = url;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/settings/screens/settings-profile/settings-profile.controller.js